'use client'

import { useRouter } from '@bprogress/next/app'
import { useTranslations } from 'next-intl'
import { AlertCircle, ArrowLeft } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { getErrorMessage } from '@/lib/utils'

type PropsType = {
  error: any
  listUrl?: string
}

const ContentError = ({ error, listUrl }: PropsType) => {
  const t = useTranslations()
  const router = useRouter()

  return (
    <div className="flex items-center justify-center py-16">
      <Card className="w-full max-w-md">
        <CardContent className="p-6 text-center">
          <AlertCircle className="mx-auto mb-4 h-12 w-12 text-red-500" />
          <h3 className="mb-2 text-lg font-semibold">{t('error')}</h3>
          <p className="text-muted-foreground mb-4">{getErrorMessage(error, t('error_loading_record'))}</p>
          {listUrl && (
            <Button onClick={() => router.push(listUrl)}>
              <ArrowLeft className="mr-2 h-4 w-4" />
              {t('list')}
            </Button>
          )}
        </CardContent>
      </Card>
    </div>
  )
}

export default ContentError
